<script>
import { derived } from 'svelte/store';

	import { scale, fade } from 'svelte/transition';
	import { currentLevelWin } from '../../stores/current-level';
	import DarkenOverlay from '../elements/DarkenOverlay.svelte';
	import Icon from '../elements/Icon.svelte';

	// Make sure the lose reason doesn't get cleared while fading out
	$: lastLoseReason = $currentLevelWin.reason || lastLoseReason;
</script>

<DarkenOverlay />

<div class="win-card" in:scale out:fade >
	<h1>Oops!</h1>

	<p>{ lastLoseReason }</p>

	<button class="large low-focus" on:click={ () => currentLevelWin.set( false ) }>
		<Icon i="arrow-left" />
		Try again
	</button>
</div>

<style>
	.win-card {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate( -50%, -50% );

		background-color: #002240;
		border: 3px solid #FFC300;
		border-radius: 20px;
		color: white;

		text-align: center;
		padding: 20px 50px;
	}

	button {
		margin: 20px;
	}
</style>
